/* ============================================================================
   Extro — comportamenti dei blocchi home (custom Extro Shop)

   Vanilla, nessuna dipendenza, caricato con defer. Tutto e' delegato o
   inizializzato per sezione, cosi' funziona anche nel Personalizzatore quando
   Shopify ricarica una singola sezione (evento shopify:section:load).

   Cosa gestisce:
     - carosello prodotti: frecce avanti/indietro e loro stato attivo/spento
     - "Mostra altri N": scopre le card gia' presenti nell'HTML ma nascoste
     - tab per stile: cambio pannello
     - foto tonde dentro al titolo dell'hero tipografico: rotazione

   Nota: i prodotti oltre i primi N sono gia' nel markup con l'attributo hidden.
   Non c'e' nessuna chiamata di rete quando si preme "Mostra altri": e' solo
   un hidden tolto. Costa qualche riga di HTML in piu' ma zero attesa.
   ============================================================================ */

(function () {
  'use strict';

  // Il tag <script> sta nello snippet condiviso, quindi su una pagina con piu'
  // blocchi compare piu' volte: il browser scarica il file una volta sola ma
  // esegue ogni tag. Senza questo guardiano registreremmo il listener del
  // Personalizzatore una volta per blocco.
  if (window.extroBlocksLoaded) return;
  window.extroBlocksLoaded = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- carosello ---------------------------------------------------------- */

  function initRail(rail) {
    if (!rail || rail.dataset.ebRailReady === 'true') return;
    rail.dataset.ebRailReady = 'true';

    var scope = rail.closest('[data-eb-rail-scope]') || rail.parentNode;
    var prev = scope.querySelector('[data-eb-prev]');
    var next = scope.querySelector('[data-eb-next]');

    function refresh() {
      // 6px di tolleranza: gli scroll frazionari non arrivano mai esatti al bordo
      var atStart = rail.scrollLeft < 6;
      // Lo snap puo' fermarsi prima del padding finale: conta l'ultimo contenuto,
      // altrimenti la freccia rimane attiva anche quando tutte le card sono visibili.
      var endPadding = parseFloat(getComputedStyle(rail).paddingRight) || 0;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - endPadding - 6;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function step(direction) {
      var first = rail.querySelector(':scope > *:not([hidden])');
      if (!first) return;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var width = first.getBoundingClientRect().width + gap;
      rail.scrollBy({
        left: direction * width * 2,
        behavior: REDUCED ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var pendingFrame = 0;
    function scheduleRefresh() {
      if (pendingFrame) return;
      pendingFrame = requestAnimationFrame(function () { pendingFrame = 0; refresh(); });
    }
    rail.addEventListener('scroll', scheduleRefresh, { passive: true });
    var observer;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(scheduleRefresh);
      observer.observe(rail);
    } else {
      window.addEventListener('resize', scheduleRefresh);
    }
    onCleanup(rail, function () {
      cancelAnimationFrame(pendingFrame);
      if (observer) observer.disconnect();
      window.removeEventListener('resize', scheduleRefresh);
    });

    refresh();
  }

  /* --- "Mostra altri N" --------------------------------------------------- */

  function initMore(button) {
    if (!button || button.dataset.ebMoreReady === 'true') return;
    button.dataset.ebMoreReady = 'true';

    function moreScope() {
      // Hero Reel ha il pulsante accanto al testo, fuori dalla griglia.
      var target = button.getAttribute('aria-controls');
      return target ? document.getElementById(target) : button.closest('[data-eb-rail], [data-eb-more-scope]');
    }

    // Il numero di nascosti non e' sempre noto a chi scrive il markup: quando i
    // reel arrivano da una collezione lo decide Liquid mentre scorre i prodotti.
    // Si conta qui e si sistema l'etichetta, o si toglie il pulsante se non
    // c'e' niente da scoprire.
    (function () {
      var ambito = moreScope();
      if (!ambito) return;

      var nascosti = ambito.querySelectorAll('[data-eb-hidden-item][hidden]').length;
      if (nascosti === 0) { button.hidden = true; return; }

      var passo = parseInt(button.dataset.ebStep, 10) || 4;
      var etichetta = button.querySelector('[data-eb-more-label]');
      var sotto = button.querySelector('[data-eb-more-sub]');
      if (etichetta && etichetta.dataset.ebTemplate) {
        etichetta.textContent = etichetta.dataset.ebTemplate.replace('[n]', Math.min(passo, nascosti));
      }
      if (sotto && sotto.dataset.ebTemplate) {
        sotto.textContent = sotto.dataset.ebTemplate.replace('[n]', nascosti);
      }
    })();

    button.addEventListener('click', function () {
      // Il pulsante vive dentro un carosello (rail prodotti) oppure dentro un
      // contenitore qualsiasi marcato come ambito, per esempio la griglia reel.
      var rail = moreScope();
      if (!rail) return;

      var step = parseInt(button.dataset.ebStep, 10) || 4;
      var hidden = rail.querySelectorAll('[data-eb-hidden-item][hidden]');
      var revealed = 0;

      for (var i = 0; i < hidden.length && revealed < step; i++) {
        hidden[i].hidden = false;
        revealed++;
      }

      var left = hidden.length - revealed;
      var counter = rail.parentNode.querySelector('[data-eb-count]');
      if (counter) {
        var shown = parseInt(counter.dataset.ebShown, 10) + revealed;
        counter.dataset.ebShown = shown;
        counter.textContent = counter.dataset.ebTemplate
          .replace('[shown]', shown)
          .replace('[total]', counter.dataset.ebTotal);
      }

      if (left <= 0) {
        button.hidden = true;
      } else {
        var label = button.querySelector('[data-eb-more-label]');
        var sub = button.querySelector('[data-eb-more-sub]');
        if (label) label.textContent = label.dataset.ebTemplate.replace('[n]', Math.min(step, left));
        if (sub) sub.textContent = sub.dataset.ebTemplate.replace('[n]', left);
      }

      // In un carosello le nuove card sono a destra, fuori campo: accompagniamo
      // lo sguardo. In una griglia non c'e' niente da scorrere.
      if (rail.hasAttribute('data-eb-rail')) {
        rail.scrollBy({ left: 400, behavior: REDUCED ? 'auto' : 'smooth' });
        rail.dispatchEvent(new Event('scroll'));
      }
    });
  }

  /* --- tab per stile ------------------------------------------------------ */

  function initTabs(group) {
    if (!group || group.dataset.ebTabsReady === 'true') return;
    group.dataset.ebTabsReady = 'true';

    var section = group.closest('.shopify-section') || document;
    var tabs = group.querySelectorAll('[role="tab"]');

    group.addEventListener('click', function (event) {
      var tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      for (var i = 0; i < tabs.length; i++) {
        var selected = tabs[i] === tab;
        tabs[i].setAttribute('aria-selected', selected ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', selected ? '0' : '-1');

        var panel = section.querySelector('#' + tabs[i].getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      }

      // Il rail del pannello appena aperto non aveva dimensioni: ricalcola le frecce
      var openPanel = section.querySelector('#' + tab.getAttribute('aria-controls'));
      var rail = openPanel && openPanel.querySelector('[data-eb-rail]');
      if (rail) rail.dispatchEvent(new Event('scroll'));
    });

    // Frecce sinistra/destra tra le tab, come da pratica ARIA
    group.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var current = document.activeElement;
      var list = Array.prototype.slice.call(tabs);
      var index = list.indexOf(current);
      if (index === -1) return;
      event.preventDefault();
      var move = event.key === 'ArrowRight' ? 1 : -1;
      var target = list[(index + move + list.length) % list.length];
      target.focus();
      target.click();
    });
  }

  var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cleanups = new WeakMap();
  var motionStates = new Map();

  function onCleanup(element, callback) {
    var section = element.closest('.shopify-section');
    if (!section) return;
    if (!cleanups.has(section)) cleanups.set(section, []);
    cleanups.get(section).push(callback);
  }

  function stopMotion(state) {
    state.groups.forEach(function (group) {
      clearTimeout(group.timer);
      group.timer = null;
    });
  }

  function updateMotion(state) {
    stopMotion(state);
    var active = state.visible && !document.hidden && !REDUCED;
    state.root.classList.toggle('eb-motion-paused', !active);
    if (!active) return;
    state.groups.forEach(function (group) {
      function rotate() {
        group.images[group.index].classList.remove('is-active');
        group.index = (group.index + 1) % group.images.length;
        group.images[group.index].classList.add('is-active');
        group.timer = setTimeout(rotate, 3200);
      }
      group.timer = setTimeout(rotate, 3200 + group.delay);
    });
  }

  var cardStates = new Map();
  var cardSelector = '.eb-rail > *, .eb-reels3 > *, [data-eb-vet-item], .eb-grid3-wide > *, .ef-product, .ef-gift, .ef-choice, .etl-card, .eb-t__grid > *';

  function animateEntrance(state, target, delay, aboveFold) {
    var preset = state.root.dataset.ebMotion;
    if (REDUCED || !preset || preset === 'none' || !target.animate) return;
    var computed = getComputedStyle(target);
    var base = computed.transform === 'none' ? '' : computed.transform;
    var start = { opacity: aboveFold ? Number(computed.opacity) * 0.85 : 0 };
    var end = { opacity: computed.opacity };
    if (preset !== 'discreet') {
      start.transform = (preset === 'scenic' ? 'translateY(32px) scale(0.97) ' : 'translateY(18px) ') + base;
      end.transform = base || 'none';
    }
    var animation = target.animate([start, end], {
      duration: preset === 'discreet' ? 420 : preset === 'elegant' ? 750 : 950,
      delay: delay,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      fill: 'backwards'
    });
    state.animations.add(animation);
    animation.onfinish = animation.oncancel = function () { state.animations.delete(animation); };
  }

  function revealCards() {
    if (document.hidden) return;
    var now = performance.now();
    cardStates.forEach(function (card, target) {
      if (!card.visible) return;
      var stagger = parseInt(card.state.root.dataset.ebStagger, 10);
      if (!Number.isFinite(stagger)) stagger = 70;
      // Mantiene la sequenza anche quando l'observer consegna card in frame diversi.
      var startAt = stagger ? Math.min(Math.max(now, card.state.nextEntrance), now + 420) : now;
      card.state.nextEntrance = startAt + stagger;
      animateEntrance(card.state, target, startAt - now, card.initiallyVisible);
      // Si osservano anche card nascoste o fuori dal carosello; una sola entrata per card.
      if (cardObserver) cardObserver.unobserve(target);
      cardStates.delete(target);
    });
  }

  var cardObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var card = cardStates.get(entry.target);
      if (card) card.visible = entry.isIntersecting && entry.intersectionRatio > 0;
    });
    revealCards();
  }, { threshold: 0.05 }) : null;

  function reveal(state) {
    if (state.revealed || !state.visible || document.hidden) return;
    state.revealed = true;
    var frame = state.root.firstElementChild;
    if (!frame) return;
    var targets = [frame];
    if (state.cards.length) {
      // Non animare il genitore delle card: annullerebbe visivamente il loro ritardo.
      targets = Array.prototype.slice.call(frame.querySelectorAll('.eb-shelf__aside, .eb-hero-reel__copy, .eb-hero-vet__media, .eb-head, .eb-sechead, .ef-heading'));
      targets = targets.filter(function (target) {
        return !state.cards.some(function (card) { return target.contains(card) || card.contains(target); });
      });
    } else if (state.root.dataset.ebMotion === 'scenic') {
      var children = Array.prototype.filter.call(frame.children, function (child) {
        return child.getClientRects().length && !child.hidden &&
          getComputedStyle(child).position !== 'absolute' && !child.matches('script, style, .eb-marquee');
      });
      if (children.length) targets = children.slice(0, 12);
    }
    targets.forEach(function (target, index) {
      animateEntrance(state, target, Math.min(index * 70, 420), state.initiallyVisible);
    });
  }

  var sectionObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = motionStates.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      updateMotion(state);
      reveal(state);
    });
  }, { threshold: 0 }) : null;

  function initMotion(root) {
    root.querySelectorAll('.extro-b').forEach(function (block) {
      if (motionStates.has(block)) return;
      // In home i contenuti compaiono subito; restano attivi slider e video.
      if (window.themeVariables?.settings.pageType === 'index') block.dataset.ebMotion = 'none';
      if ((!block.dataset.ebMotion || block.dataset.ebMotion === 'none') &&
          !block.querySelector('[data-eb-tim], .eb-marquee__track, .eb-ring, .eb-hot, .eb-title-drift')) return;
      var rect = block.getBoundingClientRect();
      var state = {
        root: block, visible: rect.bottom > 0 && rect.top < window.innerHeight,
        initiallyVisible: rect.bottom > 0 && rect.top < window.innerHeight,
        revealed: false, groups: [], cards: [], nextEntrance: 0, animations: new Set()
      };
      block.querySelectorAll('[data-eb-tim]').forEach(function (group) {
        var images = group.querySelectorAll('img');
        if (images.length < 2) return;
        state.groups.push({ images: images, index: 0, timer: null, delay: parseInt(group.dataset.ebTim, 10) || 0 });
      });
      if (block.dataset.ebMotion && block.dataset.ebMotion !== 'none') {
        var candidates = Array.prototype.slice.call(block.querySelectorAll(cardSelector)).filter(function (target) {
          return !target.matches('script, style, .eb-more, .eb-diagnostica');
        });
        state.cards = candidates.filter(function (target) {
          return !candidates.some(function (parent) { return parent !== target && parent.contains(target); });
        });
        state.cards.forEach(function (target) {
          var r = target.getBoundingClientRect();
          var visible = r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
          cardStates.set(target, { state: state, visible: false, initiallyVisible: visible });
          if (cardObserver) cardObserver.observe(target);
          // Senza IntersectionObserver il contenuto resta visibile, senza animazioni differite.
          else cardStates.delete(target);
        });
      }
      motionStates.set(block, state);
      updateMotion(state);
      reveal(state);
      if (sectionObserver) sectionObserver.observe(block);
      function cancelAnimations() {
        state.animations.forEach(function (animation) { animation.cancel(); });
      }
      block.addEventListener('focusin', cancelAnimations);
      onCleanup(block, function () {
        stopMotion(state);
        cancelAnimations();
        block.removeEventListener('focusin', cancelAnimations);
        if (sectionObserver) sectionObserver.unobserve(block);
        state.cards.forEach(function (target) {
          if (cardObserver) cardObserver.unobserve(target);
          cardStates.delete(target);
        });
        motionStates.delete(block);
      });
    });
  }

  document.addEventListener('visibilitychange', function () {
    revealCards();
    motionStates.forEach(function (state) {
      updateMotion(state);
      if (document.hidden) {
        state.animations.forEach(function (animation) { animation.finish(); });
      } else reveal(state);
    });
  });
  motionPreference.addEventListener('change', function (event) {
    REDUCED = event.matches;
    revealCards();
    motionStates.forEach(function (state) {
      if (REDUCED) state.animations.forEach(function (animation) { animation.cancel(); });
      updateMotion(state);
    });
  });

  /* --- video stories: una sola osservazione condivisa, nessun polling --- */
  var storyStates = new Map();
  var storyPageHidden = false;
  var storySDKs = {};
  var connection = navigator.connection;
  var storyObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = storyStates.get(entry.target);
      if (state) { state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35; state.sync(); }
    });
  }, { rootMargin: '0px', threshold: [0, 0.35] }) : null;

  function updateStories() { storyStates.forEach(function (state) { state.sync(); }); }
  document.addEventListener('visibilitychange', updateStories);
  window.addEventListener('pagehide', function () { storyPageHidden = true; updateStories(); });
  window.addEventListener('pageshow', function () { storyPageHidden = false; updateStories(); });
  motionPreference.addEventListener('change', updateStories);
  if (connection && connection.addEventListener) connection.addEventListener('change', updateStories);

  // Le API esterne si scaricano soltanto se una tessera esterna deve partire.
  // I video caricati su Shopify non richiedono SDK o iframe.
  function storySDK(provider) {
    if (provider === 'youtube' && window.YT && window.YT.Player) return Promise.resolve();
    if (provider === 'vimeo' && window.Vimeo && window.Vimeo.Player) return Promise.resolve();
    if (storySDKs[provider]) return storySDKs[provider];
    storySDKs[provider] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var timer = setTimeout(function () { reject(new Error('Player non disponibile')); }, 15000);
      function ready() { clearTimeout(timer); resolve(); }
      if (provider === 'youtube') {
        var previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () { try { if (previous) previous(); } finally { ready(); } };
        script.src = 'https://www.youtube.com/iframe_api';
      } else {
        script.src = 'https://player.vimeo.com/api/player.js';
        script.onload = ready;
      }
      script.onerror = function () { clearTimeout(timer); script.remove(); reject(new Error('Player non disponibile')); };
      script.async = true;
      document.head.appendChild(script);
    }).catch(function (error) { delete storySDKs[provider]; throw error; });
    return storySDKs[provider];
  }

  // Liquid può esporre solo l'originale: l'Ajax prodotto include anche i derivati.
  // La richiesta parte solo per una tessera visibile e viene condivisa per prodotto.
  var storyProducts = new Map();
  function storySource(reel, fallback) {
    var handle = reel.dataset.productHandle, mediaId = reel.dataset.videoMediaId;
    if (!handle || !mediaId) return Promise.resolve(fallback);
    if (!storyProducts.has(handle)) {
      var request = new Promise(function (resolve, reject) {
        var timer = setTimeout(function () { reject(new Error('Video: timeout sorgenti')); }, 4000);
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { if (!r.ok) throw new Error('Video: sorgenti non disponibili'); return r.json(); })
          .then(function (data) { clearTimeout(timer); resolve(data); }, function (error) { clearTimeout(timer); reject(error); });
      });
      storyProducts.set(handle, request);
      request.catch(function () { storyProducts.delete(handle); });
    }
    return storyProducts.get(handle).then(function (product) {
      var media = (product.media || []).find(function (m) { return String(m.id) === mediaId; });
      var sources = (media && media.sources || []).filter(function (s) { return s.format === 'mp4' && s.width > 0; }).sort(function (a,b) { return a.width - b.width; });
      var target = Math.min(720, Math.max(360, reel.clientWidth * Math.min(window.devicePixelRatio || 1, 1.5)));
      var source = sources.find(function (s) { return s.width >= target; }) || sources[sources.length - 1];
      return source ? source.url : fallback;
    }).catch(function () { return fallback; });
  }

  function initStory(reel) {
    if (reel.dataset.ebVideoReady === 'true') return;
    reel.dataset.ebVideoReady = 'true';
    var toggle = reel.querySelector('.eb-reel__toggle');
    var video = reel.querySelector('video');
    if (!toggle) return;
    var productLink = toggle.tagName === 'A';
    var player, playerReady, externalBox;
    var disposed = false, starting = false, playing = false, userPaused = false, manual = false, blocked = false, playSequence = 0;
    var state = { visible: false, sync: sync };
    function wanted() {
      return !disposed && reel.isConnected && state.visible && !document.hidden && !storyPageHidden && !userPaused && !blocked &&
        (manual || (reel.dataset.autoplay === 'true' && !motionPreference.matches && !(connection && connection.saveData)));
    }
    function markPlaying(value) {
      playing = value;
      reel.classList.toggle('is-playing', value);
      if (value) reel.classList.add('has-frame');
      if (!productLink) {
        toggle.setAttribute('aria-pressed', String(value));
        toggle.setAttribute('aria-label', (value ? 'Metti in pausa il video ' : 'Riproduci il video ') + (reel.dataset.productTitle || ''));
      }
    }
    function pause() {
      playSequence++;
      starting = false;
      if (video) video.pause();
      if (player) {
        if (reel.dataset.provider === 'youtube' && player.pauseVideo) player.pauseVideo();
        else if (player.pause) player.pause().catch(function () {});
      }
      markPlaying(false);
    }
    function external() {
      if (playerReady) return playerReady;
      playerReady = storySDK(reel.dataset.provider).then(function () {
        if (disposed) return;
        externalBox = document.createElement('div');
        externalBox.className = 'eb-reel__external';
        reel.appendChild(externalBox);
        return new Promise(function (resolve, reject) {
          function ready() {
            var frame = externalBox && externalBox.querySelector('iframe');
            if (frame) { frame.setAttribute('tabindex', '-1'); frame.setAttribute('aria-hidden', 'true'); }
            resolve();
          }
          if (reel.dataset.provider === 'youtube') {
            var mount = document.createElement('div');
            externalBox.appendChild(mount);
            player = new window.YT.Player(mount, {
              videoId: reel.dataset.videoId,
              playerVars: { autoplay: 0, controls: 0, playsinline: 1, loop: 1, playlist: reel.dataset.videoId, rel: 0, origin: location.origin },
              events: {
                onReady: function (event) { if (!disposed) event.target.mute(); ready(); },
                onStateChange: function (event) {
                  if (event.data === 1) { if (wanted()) markPlaying(true); else pause(); }
                  else if (event.data === 2 || event.data === 0) markPlaying(false);
                },
                onAutoplayBlocked: function () { blocked = true; markPlaying(false); },
                onError: function () { blocked = true; markPlaying(false); reject(new Error('Video non disponibile')); }
              }
            });
          } else {
            player = new window.Vimeo.Player(externalBox, {
              id: reel.dataset.videoId, autoplay: false, muted: true, loop: true, controls: false, autopause: false, playsinline: true
            });
            player.on('playing', function () { if (wanted()) markPlaying(true); else pause(); });
            player.on('pause', function () { markPlaying(false); });
            player.ready().then(ready, reject);
          }
        });
      });
      return playerReady;
    }
    function start() {
      if (starting || playing) return;
      starting = true;
      var sequence = ++playSequence;
      var result, interrupted = false;
      if (video) {
        var source = video.querySelector('source[data-src]');
        result = (source ? storySource(reel, source.dataset.src) : Promise.resolve()).then(function (url) {
          if (sequence !== playSequence || !wanted()) return;
          if (source) { video.dataset.originalSrc = source.dataset.src; source.src = url; source.removeAttribute('data-src'); video.load(); }
          video.muted = true;
          if (video.error) video.load();
          return video.play();
        });
      } else {
        result = external().then(function () {
          if (sequence !== playSequence || !wanted()) return;
          if (reel.dataset.provider === 'youtube') { player.mute(); player.playVideo(); }
          else return player.play();
        });
      }
      Promise.resolve(result).then(function () { if (sequence === playSequence && !wanted()) pause(); })
        .catch(function (error) {
          if (sequence !== playSequence) return;
          // Un cambio scheda puo' interrompere play() prima che la promessa si risolva.
          interrupted = error && error.name === 'AbortError';
          if (!interrupted && wanted()) blocked = true;
          markPlaying(false);
        })
        .finally(function () {
          if (sequence !== playSequence) return;
          starting = false;
          if (wanted() && (interrupted || (video && video.paused))) start();
        });
    }
    function sync() { if (wanted()) start(); else pause(); }
    function onClick() {
      state.visible = true;
      if (playing || (starting && wanted())) { userPaused = true; manual = false; }
      else {
        if (blocked && !video && !starting) {
          if (player && player.destroy) Promise.resolve(player.destroy()).catch(function () {});
          if (externalBox) externalBox.remove();
          player = null; playerReady = null; externalBox = null;
        }
        userPaused = false; manual = true; blocked = false;
      }
      sync();
    }
    function onPlaying() { if (wanted()) markPlaying(true); else pause(); }
    function onPause() { markPlaying(false); }
    function onError() {
      var source = video && video.querySelector('source');
      if (source && video.dataset.originalSrc && source.getAttribute('src') !== video.dataset.originalSrc) {
        // Un derivato indisponibile non deve togliere il video: riprova l'originale.
        playSequence++; starting = false; markPlaying(false);
        source.src = video.dataset.originalSrc; video.load();
        if (wanted()) start();
        return;
      }
      blocked = true; markPlaying(false); reel.classList.remove('has-frame');
    }
    if (!productLink) toggle.addEventListener('click', onClick);
    if (video) {
      video.addEventListener('playing', onPlaying);
      video.addEventListener('pause', onPause);
      video.addEventListener('error', onError);
    }
    storyStates.set(reel, state);
    if (storyObserver) storyObserver.observe(reel);
    // Senza IntersectionObserver restano i link prodotto o i comandi espliciti.
    onCleanup(reel, function () {
      disposed = true;
      pause();
      if (storyObserver) storyObserver.unobserve(reel);
      storyStates.delete(reel);
      if (!productLink) toggle.removeEventListener('click', onClick);
      if (video) {
        video.removeEventListener('playing', onPlaying);
        video.removeEventListener('pause', onPause);
        video.removeEventListener('error', onError);
        var source = video.querySelector('source[src]');
        if (source) { source.dataset.src = source.getAttribute('src'); source.removeAttribute('src'); video.load(); }
      }
      if (player && player.destroy) Promise.resolve(player.destroy()).catch(function () {});
      if (externalBox) externalBox.remove();
      reel.classList.remove('has-frame');
      delete reel.dataset.ebVideoReady;
    });
  }

  /* --- reel: riproduzione al passaggio del mouse -------------------------- */

  function initVideo(reel) {
    if (reel && reel.hasAttribute('data-eb-story')) { initStory(reel); return; }
    if (!reel || reel.dataset.ebVideoReady === 'true') return;
    reel.dataset.ebVideoReady = 'true';

    var toggle = reel.querySelector('.eb-reel__toggle');
    var video = reel.querySelector('video');
    var embed = reel.dataset.embed;
    if (!toggle) return;

    function avvia() {
      // Video esterno: l'iframe si crea adesso, al primo clic. Prima non
      // esisteva proprio, quindi non ha pesato sul caricamento della pagina.
      if (embed) {
        if (reel.querySelector('iframe')) return;
        var frame = document.createElement('iframe');
        frame.className = 'eb-reel__iframe';
        frame.src = embed;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.setAttribute('allowfullscreen', '');
        frame.setAttribute('title', toggle.getAttribute('aria-label') || 'Video');
        reel.appendChild(frame);
        reel.classList.add('is-playing');
        return;
      }

      if (!video) return;

      // play() torna una promessa che il browser rifiuta in vari casi leciti
      // (scheda in secondo piano, risparmio energetico): senza catch finirebbe
      // in console come errore non gestito, e la copertina resterebbe coperta
      // da un rettangolo nero.
      var partito = video.play();
      if (partito && partito.then) {
        partito.then(function () { reel.classList.add('is-playing'); })
               .catch(function () { reel.classList.remove('is-playing'); });
      } else {
        reel.classList.add('is-playing');
      }
    }

    function ferma() {
      if (!video) return;
      video.pause();
      video.currentTime = 0;
      reel.classList.remove('is-playing');
    }

    // Il clic e' la via principale, e vale ovunque: su telefono e' l'unica.
    toggle.addEventListener('click', function () {
      if (embed) { avvia(); return; }
      if (video && !video.paused) { ferma(); } else { avvia(); }
    });

    // Al passaggio del mouse solo se richiesto, e solo dove un puntatore c'e'
    // davvero: su touch il browser simula l'hover al primo tocco, e il video
    // partirebbe da solo.
    if (reel.dataset.hover !== '1' || REDUCED) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (embed) return;

    reel.addEventListener('mouseenter', avvia);
    reel.addEventListener('mouseleave', ferma);
  }

  /* --- vetrina: gruppi di prodotti su desktop ----------------------------- */

  function initVetrina(griglia) {
    if (!griglia || griglia.dataset.ebVetrinaReady === 'true') return;
    griglia.dataset.ebVetrinaReady = 'true';

    var items = griglia.querySelectorAll('[data-eb-vet-item]');
    if (!items.length) return;

    var scope = griglia.parentNode;
    var pager = scope.querySelector('[data-eb-vet-pager]');
    var prev = scope.querySelector('[data-eb-vet-prev]');
    var next = scope.querySelector('[data-eb-vet-next]');

    var collectionLink = scope.querySelector('.eb-hero-vet__link, .eb-headlink');
    var baseUrl = collectionLink && new URL(collectionLink.href, location.href);
    var resumeLinks = baseUrl ? Array.prototype.filter.call(griglia.closest('.extro-b').querySelectorAll('a[href]'), function (link) {
      var destination = new URL(link.href, location.href);
      return destination.origin === baseUrl.origin && destination.pathname === baseUrl.pathname;
    }) : [];
    function remember(item) {
      if (!baseUrl || !item || !item.dataset.ebProduct) return;
      var url = new URL(baseUrl.href);
      url.searchParams.set('extro_product', item.dataset.ebProduct);
      url.searchParams.set('extro_position', item.dataset.ebPosition);
      resumeLinks.forEach(function (link) { link.href = url.href; });
    }

    var perPagina = parseInt(griglia.dataset.perPagina, 10) || 6;
    var pagina = 0;

    // Su mobile la foto di campagna sta sopra e non c'e' proporzione da
    // difendere: i prodotti si vedono tutti, e il raggruppamento si spegne.
    var desktop = window.matchMedia('(min-width: 901px)');

    function pagine() {
      return Math.ceil(items.length / perPagina);
    }

    function disegna() {
      var raggruppa = desktop.matches && items.length > perPagina;

      for (var i = 0; i < items.length; i++) {
        var dentro = !raggruppa ||
          (i >= pagina * perPagina && i < (pagina + 1) * perPagina);
        items[i].hidden = !dentro;
      }

      if (desktop.matches) {
        var lastProduct;
        items.forEach(function (item) { if (!item.hidden && item.dataset.ebProduct) lastProduct = item; });
        // L'ultima pagina puo' contenere soltanto la card della collezione.
        if (!lastProduct) lastProduct = griglia.querySelector('[data-eb-product]:nth-last-child(2)');
        remember(lastProduct);
      }
      if (pager) pager.hidden = !raggruppa;
      if (!raggruppa) return;

      if (prev) prev.disabled = pagina === 0;
      if (next) next.disabled = pagina >= pagine() - 1;
    }

    if (prev) prev.addEventListener('click', function () {
      if (pagina > 0) { pagina--; disegna(); }
    });
    if (next) next.addEventListener('click', function () {
      if (pagina < pagine() - 1) { pagina++; disegna(); }
    });

    // Una pagina per gesto: l'inerzia del trackpad non deve saltare altri gruppi.
    // La rotella verticale e lo zoom restano gestiti dal browser.
    var wheelTime = 0, wheelTotal = 0, wheelDirection = 0, wheelUsed = false;
    function resetWheel() {
      wheelTime = 0; wheelTotal = 0; wheelDirection = 0; wheelUsed = false;
    }
    function onWheel(event) {
      if (!desktop.matches || pagine() <= 1 || event.ctrlKey || event.defaultPrevented) return;
      var delta = event.deltaX;
      if (event.shiftKey && !delta) delta = event.deltaY;
      if (!delta || (!event.shiftKey && Math.abs(delta) <= Math.abs(event.deltaY))) return;
      var direction = delta > 0 ? 1 : -1;
      var now = performance.now();
      if (now - wheelTime > 180 || direction !== wheelDirection) resetWheel();
      wheelTime = now;
      wheelDirection = direction;
      var target = pagina + direction;
      if (!wheelUsed && (target < 0 || target >= pagine())) return;
      event.preventDefault();
      if (wheelUsed) return;
      wheelTotal += delta * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? griglia.clientWidth : 1);
      if (Math.abs(wheelTotal) < 40) return;
      wheelUsed = true;
      pagina = target;
      disegna();
    }
    griglia.addEventListener('wheel', onWheel, { passive: false });

    // Passando da desktop a telefono il gruppo corrente non ha piu' senso:
    // si torna al primo e si mostrano tutti.
    var alCambio = function () { pagina = 0; resetWheel(); disegna(); };
    if (desktop.addEventListener) {
      desktop.addEventListener('change', alCambio);
    } else if (desktop.addListener) {
      desktop.addListener(alCambio);
    }

    var seenObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      if (desktop.matches) return;
      entries.forEach(function (entry) { if (entry.isIntersecting) remember(entry.target); });
    }, { threshold: 0.5 }) : null;
    if (seenObserver) griglia.querySelectorAll('[data-eb-product]').forEach(function (item) { seenObserver.observe(item); });

    onCleanup(griglia, function () {
      griglia.removeEventListener('wheel', onWheel);
      if (seenObserver) seenObserver.disconnect();
      if (desktop.removeEventListener) desktop.removeEventListener('change', alCambio);
      else if (desktop.removeListener) desktop.removeListener(alCambio);
    });
    disegna();
  }

  /* --- avvio -------------------------------------------------------------- */

  function initTipoSpacing(hero) {
    if (hero.dataset.ebTipoReady === 'true') return;
    var text = hero.querySelector('.eb-hero-tipo__first-text');
    var logo = hero.querySelector('.eb-hero-tipo__logo-row img');
    if (!text || !text.textContent.trim() || !logo) return;
    hero.dataset.ebTipoReady = 'true';
    var heading = text.closest('h2');
    var canvas = document.createElement('canvas').getContext('2d');
    if (!canvas) return;
    var frame = 0, disposed = false;
    function measure() {
      frame = 0;
      if (disposed || !hero.isConnected || !hero.getClientRects().length) return;
      var range = document.createRange();
      range.selectNodeContents(text);
      var firstLine = range.getClientRects()[0];
      if (!firstLine || !firstLine.height) return;
      var style = getComputedStyle(text);
      canvas.font = style.fontStyle + ' ' + style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
      var metrics = canvas.measureText(text.textContent.trim());
      if (!Number.isFinite(metrics.fontBoundingBoxDescent) || !Number.isFinite(metrics.actualBoundingBoxAscent)) return;
      var previous = parseFloat(hero.style.getPropertyValue('--eb-tipo-title-lift')) || 0;
      var inkTop = firstLine.bottom - metrics.fontBoundingBoxDescent - metrics.actualBoundingBoxAscent;
      var lift = previous + inkTop - logo.getBoundingClientRect().bottom - 4;
      // Il cerchio puo' salire accanto al logo, senza urtare testo o pulsante.
      var limit = heading.getBoundingClientRect().top + previous - hero.getBoundingClientRect().top;
      var photo = heading.querySelector('.eb-tim');
      if (photo) {
        var photoBox = photo.getBoundingClientRect();
        hero.querySelectorAll('.eb-hero-tipo__logo-row img, .eb-hero-tipo__intro .eb-eyebrow, .eb-hero-tipo__top .eb-btn').forEach(function (element) {
          if (!element.getClientRects().length) return;
          var box = element.getBoundingClientRect();
          if (photoBox.left < box.right && photoBox.right > box.left) {
            limit = Math.min(limit, photoBox.top + previous - box.bottom - 4);
          }
        });
      }
      lift = Math.max(0, Math.min(lift, limit));
      if (Math.abs(previous - lift) > 0.5) hero.style.setProperty('--eb-tipo-title-lift', lift.toFixed(2) + 'px');
    }
    function schedule() {
      if (!disposed && !frame) frame = requestAnimationFrame(measure);
    }
    var observer = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    if (observer) { observer.observe(hero); observer.observe(logo); }
    else window.addEventListener('resize', schedule);
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
    schedule();
    onCleanup(hero, function () {
      disposed = true;
      cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      window.removeEventListener('resize', schedule);
      if (document.fonts) document.fonts.removeEventListener('loadingdone', schedule);
      delete hero.dataset.ebTipoReady;
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-eb-rail]').forEach(initRail);
    scope.querySelectorAll('[data-eb-more]').forEach(initMore);
    scope.querySelectorAll('[data-eb-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-eb-reel]').forEach(initVideo);
    scope.querySelectorAll('[data-eb-vetrina]').forEach(initVetrina);
    scope.querySelectorAll('.eb-hero-tipo').forEach(initTipoSpacing);
    initMotion(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var callbacks = cleanups.get(event.target);
    if (callbacks) callbacks.forEach(function (cleanup) { cleanup(); });
    cleanups.delete(event.target);
  });

  // Personalizzatore: quando una sezione viene ricaricata va reinizializzata
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
